if(!customElements.get('custom-complementary-products')){
    class ComplementaryProducts extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.paddingTop = this.dataset.paddingTop;
            this.paddingBottom = this.dataset.paddingBottom;
            const handleIntersection = (entries, observer) => {
                if (!entries[0].isIntersecting) return;
                observer.unobserve(this);

                fetch(this.dataset.url)
                .then(res => res.text())
                .then(text => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    
                    const recommendations = html.querySelector('custom-complementary-products');

                    if(recommendations && recommendations.innerHTML.trim().length){
                        this.innerHTML = recommendations.innerHTML;

                        if(html.querySelectorAll('.complementary-products__product-wrapper .product-card').length > 0){
                            if(this.paddingTop) this.style.paddingTop = `${this.paddingTop}px`;
                            if(this.paddingBottom) this.style.paddingBottom = `${this.paddingBottom}px`;
                        }
                    }

                    this.swiperContainer = this.querySelector('.swiper-container');

                    this.initSwiper();

                    if(html.querySelector('.swiper-slide')){
                        this.setAttribute('data-loaded',' true');
                    }
                })
                .catch(e=> {
                    console.error(e);
                });
            }

            new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
        }

        refresh(){
            this.init();
        }

        initSwiper(){
            if(!this.swiperContainer) return;
            if(totalSlides == 1) return;

            var totalSlides = parseInt(this.swiperContainer.dataset.totalSlides);
            var numPerView = (this.dataset.type == 'full-width')? parseInt(this.swiperContainer.dataset.numPerView) : 3;
            var slidesPerView = (numPerView && totalSlides > numPerView)? numPerView : totalSlides;
            var loop = (this.swiperContainer.dataset.loop == 'true')? true : false;
            
            var breakpoints = {};
            if(this.dataset.type == 'full-width'){
                breakpoints = {
                    0: {
                        slidesPerView: 1
                    },
                    567: {
                        slidesPerView: slidesPerView < 2? slidesPerView : 2
                    },
                    991: {
                        slidesPerView: slidesPerView < 3? slidesPerView : 3
                    },
                    1200: {
                        slidesPerView: slidesPerView
                    }
                }
            }else{
                breakpoints = {
                    0: {
                        slidesPerView: 1
                    },
                    300: {
                        slidesPerView: slidesPerView < 2? slidesPerView : 2
                    },
                    567: {
                        slidesPerView: slidesPerView < 3? slidesPerView : 3
                    },
                    991: {
                        slidesPerView: slidesPerView < 2? slidesPerView : 2
                    },
                    1200: {
                        slidesPerView: slidesPerView
                    }
                }
            }

            var swiperSettings = {
                init: true,
                initialSlides: 0,
                loop: loop,
                spaceBetween: 10,
                centeredSlides: false,
                speed: 500,
                watchOverflow: true,
                breakpoints: breakpoints,
                observer: true,
                observeSlideChildren: true
            }

            if(this.swiperContainer.querySelector('.swiper-pagination')){
                swiperSettings.pagination = {
                  el: this.swiperContainer.querySelector('.swiper-pagination')
                }
            }

            if(this.swiperContainer.querySelector('.swiper-button-next')){
                swiperSettings.navigation = {
                  nextEl: this.swiperContainer.querySelector('.swiper-button-next'),
                  prevEl: this.swiperContainer.querySelector('.swiper-button-prev')
                }
            }

            if(this.swiperContainer.dataset.autoplay == 'true'){
                let speed = this.swiperContainer.dataset.speed;
                speed = parseInt(speed) * 1000;
                swiperSettings.autoplay = {
                    delay: speed
                }
            }

            this.swiper = new Swiper(this.swiperContainer, swiperSettings);
            this.swiper.init();
            this.getVisibleSlides();
            this.checkPagination();

            this.swiper.on('slideChange', () => {
                this.getVisibleSlides();
            });

            this.swiper.on('resize' ,() => {
                this.checkPagination();
            });
        }

        getVisibleSlides(){
            if(this.swiper){
                const allSlides = this.swiper.slides;
                const activeIndex = this.swiper.activeIndex;
                const slidesPerView = this.swiper.params.slidesPerView;

                const visibleSlides = [];
                
                if(slidesPerView === 'auto'){
                    allSlides.forEach((slide) => {
                        const rect = slide.getBoundingClientRect();
                        if (rect.left >= 0 && rect.right <= window.innerWidth) {
                            visibleSlides.push(slide);
                        }
                    });
                }else{
                    for (let i = activeIndex; i < activeIndex + slidesPerView && i < allSlides.length; i++) {
                        visibleSlides.push(allSlides[i]);
                    }
                }
    
                allSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '-1');
                    });
                });
    
                visibleSlides.forEach((slide) => {
                    slide.querySelectorAll('.tab-able-item').forEach((item) => {
                        item.setAttribute('tabindex', '0');
                    });
                });
            }
        }
        
        checkPagination(){
            var pagination = this.querySelector('.swiper-pagination');
            var btns = {
                prev: this.querySelector('.swiper-button-prev'),
                next: this.querySelector('.swiper-button-next')
            }
            if(pagination && pagination.querySelectorAll('.swiper-pagination-bullet').length <= 1){
                pagination.classList.add('d-none');
                if(btns.prev) btns.prev.style.display = 'none';
                if(btns.next) btns.next.style.display = 'none';
            }else{
                if(pagination) pagination.classList.remove('d-none');
                if(btns.prev) btns.prev.style.display = 'block';
                if(btns.next) btns.next.style.display = 'block';
            }
        }
    }

    customElements.define('custom-complementary-products', ComplementaryProducts);
}